import { EMPTY_CELL_VALUE } from '../../../../components/EmptyCell'
import { IStatusConfig } from '../../../../components/StatusBadge'
import {
  EventTabItemOrigin,
  EventTabItemStatus,
  EventTabMachine,
  EventTabStatus,
  EventTabSummary,
  TerminalPaymentMethod,
  TerminalPaymentStatus
} from '../../../../services/Event/types'

export const TAB_STATUS: Record<EventTabStatus, IStatusConfig> = {
  open: { label: 'Aberta', colorScheme: 'orange' },
  closed: { label: 'Fechada', colorScheme: 'gray' }
}

export const TAB_ITEM_STATUS: Record<EventTabItemStatus, IStatusConfig> = {
  open: { label: 'A cobrar', colorScheme: 'orange' },
  paid: { label: 'Paga', colorScheme: 'green' },
  cancelled: { label: 'Cancelada', colorScheme: 'gray' }
}

export const TAB_ITEM_ORIGIN: Record<EventTabItemOrigin, string> = {
  auction: 'Lance no leilão',
  partner: 'Celular do parceiro',
  checkout: 'Lançado no checkout'
}

/** Forma de pagamento no terminal ou no celular: os pagamentos da comanda e as vendas na porta (ABRA-319). */
export const PAYMENT_METHOD: Record<TerminalPaymentMethod, IStatusConfig> = {
  credit: { label: 'Crédito (Stone)', colorScheme: 'purple' },
  debit: { label: 'Débito (Stone)', colorScheme: 'blue' },
  pix: { label: 'PIX (Stone)', colorScheme: 'teal' },
  pix_manual: { label: 'PIX manual', colorScheme: 'teal' },
  cash: { label: 'Dinheiro', colorScheme: 'green' },
  credit_manual: { label: 'Crédito manual', colorScheme: 'purple' },
  debit_manual: { label: 'Débito manual', colorScheme: 'blue' },
  other: { label: 'Outro', colorScheme: 'gray' }
}

/** Situação do pagamento no terminal — não é o `PAYMENT_STATUS` das compras. */
export const TERMINAL_STATUS: Record<TerminalPaymentStatus, IStatusConfig> = {
  approved: { label: 'Aprovado', colorScheme: 'green' },
  voided: { label: 'Estornado', colorScheme: 'red' }
}

export const voidReasonLabels: Record<string, string> = {
  customer_request: 'Solicitação do cliente',
  wrong_amount: 'Valor incorreto',
  other: 'Outro'
}

export const deviceTypeLabels: Record<string, string> = {
  terminal: 'Terminal POS',
  tablet: 'Tablet',
  phone: 'Celular'
}

/** `Maquininha 01 · Terminal POS`. */
export function machineLabel(machine: EventTabMachine | null): string {
  if (!machine) return EMPTY_CELL_VALUE
  return `${machine.name} · ${deviceTypeLabels[machine.device_type] ?? machine.device_type}`
}

/** The panel's check-out has no device: payments and removals it made show this (ABRA-425). */
export const PANEL_LABEL = 'Painel'

/** A comanda fechada pelo painel não tem dispositivo de checkout. */
export function checkoutLabel(tab: Pick<EventTabSummary, 'close_reason' | 'checkout_machine'>): string {
  return tab.close_reason === 'admin_closed' ? 'Fechada pelo painel' : machineLabel(tab.checkout_machine)
}
